<h2 mat-dialog-title>Generate Pictures Report</h2>

<mat-dialog-content>
  <p class="subtitle">Choose an option</p>

  <mat-radio-group class="radio-group" [(ngModel)]="selectedMode">
    <mat-radio-button class="radio-option" color="primary" value="template">
      Select from predefined Pictures templates
    </mat-radio-button>

    <mat-form-field class="template-select" appearance="outline">
      <mat-label>Template</mat-label>
      <mat-select [(ngModel)]="selectedTemplate" [disabled]="selectedMode === 'blank'">
        @for (template of templates; track template.id) {
          <mat-option [value]="template">{{ template.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-radio-button class="radio-option" color="primary" value="blank">
      Create report from blank
    </mat-radio-button>
  </mat-radio-group>
</mat-dialog-content>

<mat-dialog-actions style="margin-bottom: 12px; margin-left: 12px; margin-right: 12px;">
  <button (click)="cancel()" mat-stroked-button color="primary">CANCEL</button>
  <span class="spacer"></span>
  @if (selectedMode === 'template') {
    <button
      mat-stroked-button
      color="primary"
      [disabled]="!canSelect"
      (click)="edit()"
    >
      EDIT
    </button>
  }
  @if (selectedMode === 'blank') {
    <button
      [disabled]="!canSelect"
      (click)="create()"
      mat-flat-button
      color="primary"
    >
      CREATE
    </button>
  } @else {
    <button
      [disabled]="!canSelect"
      (click)="generate()"
      mat-flat-button
      color="primary"
    >
      GENERATE
    </button>
  }
</mat-dialog-actions>
